export default {
  ShowQuantity: 0,
  HideQuantity: 1,
};
